module.exports = __webpack_public_path__ + "static/media/datos.89bac7e5.svg";